/** Centers `item` in its scrollable `container`; unlike `scrollIntoView` it leaves the page and other ancestors alone. */
export function scrollToCenter(container: HTMLElement, item: Element) {
  const offset = item.getBoundingClientRect().top - container.getBoundingClientRect().top
  container.scrollTop += offset - (container.clientHeight - item.clientHeight) / 2
}
